/* eslint-disable import/no-anonymous-default-export */
const AUTH = 'oauth';
const LOGIN = `${AUTH}/login`;
const AUTH_ME = `${AUTH}/me`;
const SETTINGS = 'settings';
const USER_DESIGNATION = `/designations/autocomplete`;
const CREATE_USER = `/users`;
const USERNAME_AVAILABLE = `${CREATE_USER}/username/availability`;
// const FORGOT_PASSWORD = `/${AUTH}/forgot`;
const FORGOT_PASSWORD = `/${AUTH}/password`;
const FORGOT_PASSWORD_CODE = `/${AUTH}/verify-code`;
const SET_NEW_PASSWORD = `/${AUTH}/password`;
const GET_HOLIDAY = `/holidays`;
const SET_NEW_PIN = `${AUTH}/passcode`;
const VERIFY_PIN = `${AUTH}/verify-passcode`;
const CHANGE_PASSWORD = `${SETTINGS}/password`;
const LANGUAGES = '/languages';
const THEMES = '/themes';
const USER_AUTOCOMPLETE = `${CREATE_USER}/autocomplete`;
const RESEND_CODE = `/${AUTH}/send-code`;
const CREATE_GROUPS = `/groups`;
const UPLOAD_IMAGE = `/upload`;
const ARCHIVE_GROUP = `${CREATE_GROUPS}`;
const CHANGE_PIN = `${SETTINGS}/pin`;
const SETTING_UPLOAD = `${SETTINGS}/upload`;
const SETTING_UPDATE = `${SETTINGS}/profile`;
const GROUP_DETAILS = `${CREATE_GROUPS}`;
const CREATE_ACCOUNT = 'accounts';
const RESET_SLOTS = `${CREATE_USER}`;
const DASHBOARD_STATS_URL = `stats?frequency=monthly`;
const CLINIC_LISTING = `accounts`;
const UNREAD_MESSAGES_COUNT = '/messages/my_unread_count';

export default {
  UNREAD_MESSAGES_COUNT,
  DASHBOARD_STATS_URL,
  LOGIN,
  AUTH_ME,
  USER_DESIGNATION,
  CREATE_USER,
  USERNAME_AVAILABLE,
  FORGOT_PASSWORD,
  VERIFY_PIN,
  FORGOT_PASSWORD_CODE,
  SET_NEW_PASSWORD,
  GET_HOLIDAY,
  CHANGE_PASSWORD,
  SET_NEW_PIN,
  LANGUAGES,
  THEMES,
  USER_AUTOCOMPLETE,
  RESEND_CODE,
  CREATE_GROUPS,
  UPLOAD_IMAGE,
  ARCHIVE_GROUP,
  CHANGE_PIN,
  SETTING_UPLOAD,
  SETTING_UPDATE,
  GROUP_DETAILS,
  CREATE_ACCOUNT,
  RESET_SLOTS,
  CLINIC_LISTING,
};
